import { OnInit, Type } from '@angular/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Entity } from 'src/app/core/data/schema/entity';
import { Log } from 'src/app/core/log';

@Component({
  selector: 'app-suggest-input',
  templateUrl: 'suggest-input.html',
  styleUrls: ['./suggest-input.scss'],
})
export class SuggestInputComponent implements OnInit {

  @Output() objectSelected: EventEmitter<any> = new EventEmitter();

  @Input() initialValue: string;
  @Input() inputLabel: string;
  @Input() noSuggestionsMsg: string;
  @Input() stringProperty: string;
  @Input() placeholder: string;
  @Input() arrayOfObjects: any[] = [];
  @Input() entityClass: Type<Entity>;
  @Input() margin: string;

  filteredObjects: any[] = [];
  selectedString: string;
  selectedObject: string;
  selectedIdx: number = -1; // index of suggestions selected

  ignoreNextChange: boolean = false; // once a value is selected, stop searching
  noSuggestionsFound: boolean = false;

  isFetching: boolean = false;
  
  constructor() {
  }

  ngOnInit() {
    if (this.initialValue != null) {
      this.ignoreNextChange = true;
      this.selectedString = this.initialValue;
    }
  }

  async onTyping(event: any) {


    if (this.ignoreNextChange) {
      this.ignoreNextChange = false;
      return;
    }
    const substring = event.detail.value.toLowerCase();

    // don't show anything if less than 2 characters entered
    if (substring.length < 3) {
      this.filteredObjects = [];
      this.noSuggestionsFound = true;
      this.noSuggestionsMsg = 'type at least 3 letters to search';
      return;
    }

    if (this.isFetching ){
      return;
    }
    this.isFetching = true;

    // check to see if we have any items to filter
    // if (this.arrayOfObjects.length == 0) { // this would prevent loading new set of users if string changed
      // go to the server calling the Filter event on the entity
      this.arrayOfObjects = await this.entityClass['findMatching'](this.entityClass, substring);
    // }
    this.isFetching = false;


    // for now just filter existing list
    this.filteredObjects = this.arrayOfObjects.filter(m => {
      return m.name.toLowerCase().indexOf(substring) >= 0;
    });
    this.noSuggestionsFound = this.filteredObjects.length == 0;
    if (this.noSuggestionsFound) {
      this.noSuggestionsMsg = `No matches for string '${substring}'`;
    }
  }

  focus() {
    // this.filteredObjects = this.arrayOfObjects;
    // if ( this.filteredObjects.length == 0){
    //   this.noSuggestionsFound = true;
    // } else {
    //   this.noSuggestionsFound = false
    // }
  }

  blur() {
    setTimeout(() => {
      this.filteredObjects = [];
    }, 100);
    this.noSuggestionsFound = false
  }

  arrowUp() {
    // increment selCompIdx to highlight and enable select
    if (this.selectedIdx > 0) {
      this.selectedIdx--;
      Log.debug(' idx now ' + this.selectedIdx);
    }
  }
  arrowDown() {
    // increment selCompIdx to highlight and enable select
    if (this.selectedIdx < this.filteredObjects.length - 1) {
      this.selectedIdx++;
      Log.debug(' idx now ' + this.selectedIdx);
    }
  }

  select() {
    if (this.selectedIdx >= 0 && this.selectedIdx <= this.filteredObjects.length - 1) {
      this.valueSelected(this.filteredObjects[this.selectedIdx]);
    }
  }

  async valueSelected(selected: any) {
    this.selectedObject = selected;
    this.selectedString = this.selectedObject[this.stringProperty];
    this.filteredObjects = [];
    this.ignoreNextChange = true;

    this.objectSelected.emit(this.selectedObject);
  }

}
